/**
 * Die Bilder des Hauptmenues (Rueckmeldung vom 15.10.2026: "in so einem
 * Stil wie die Homepage").
 *
 * Erzeugt mit apps/client/scripts/menue-bilder.mjs aus denselben Originalen
 * wie die Homepage. Je Bild mehrere Breiten in zwei Formaten: AVIF ist
 * kleiner, WebP versteht jeder Browser - der Browser nimmt das erste, das er
 * kann, und davon die kleinste Breite, die fuer seinen Bildschirm reicht.
 */

import hintergrund960Avif from '../assets/menue/hintergrund-960.avif';
import hintergrund960Webp from '../assets/menue/hintergrund-960.webp';
import hintergrund1600Avif from '../assets/menue/hintergrund-1600.avif';
import hintergrund1600Webp from '../assets/menue/hintergrund-1600.webp';
import hintergrund2400Avif from '../assets/menue/hintergrund-2400.avif';
import hintergrund2400Webp from '../assets/menue/hintergrund-2400.webp';
import schriftzug480Avif from '../assets/menue/schriftzug-480.avif';
import schriftzug480Webp from '../assets/menue/schriftzug-480.webp';
import schriftzug960Avif from '../assets/menue/schriftzug-960.avif';
import schriftzug960Webp from '../assets/menue/schriftzug-960.webp';
import schriftzug1440Avif from '../assets/menue/schriftzug-1440.avif';
import schriftzug1440Webp from '../assets/menue/schriftzug-1440.webp';
import lbrovan240Avif from '../assets/menue/linebound-rovan-240.avif';
import lbrovan240Webp from '../assets/menue/linebound-rovan-240.webp';
import lbrovan480Avif from '../assets/menue/linebound-rovan-480.avif';
import lbrovan480Webp from '../assets/menue/linebound-rovan-480.webp';
import lbaelys240Avif from '../assets/menue/linebound-aelys-240.avif';
import lbaelys240Webp from '../assets/menue/linebound-aelys-240.webp';
import lbaelys480Avif from '../assets/menue/linebound-aelys-480.avif';
import lbaelys480Webp from '../assets/menue/linebound-aelys-480.webp';
import lbcalder240Avif from '../assets/menue/linebound-calder-240.avif';
import lbcalder240Webp from '../assets/menue/linebound-calder-240.webp';
import lbcalder480Avif from '../assets/menue/linebound-calder-480.avif';
import lbcalder480Webp from '../assets/menue/linebound-calder-480.webp';
import lbvessa240Avif from '../assets/menue/linebound-vessa-240.avif';
import lbvessa240Webp from '../assets/menue/linebound-vessa-240.webp';
import lbvessa480Avif from '../assets/menue/linebound-vessa-480.avif';
import lbvessa480Webp from '../assets/menue/linebound-vessa-480.webp';

export interface Bildquellen {
  avif: string;
  webp: string;
  /** Die kleinste Fassung - fuer Browser, die srcset nicht kennen. */
  ersatz: string;
}

/** Das Kopfbild der Homepage: die vier Linebounds vor den beiden Toren. */
export const MENUE_HINTERGRUND: Bildquellen = {
  avif: `${hintergrund960Avif} 960w, ${hintergrund1600Avif} 1600w, ${hintergrund2400Avif} 2400w`,
  webp: `${hintergrund960Webp} 960w, ${hintergrund1600Webp} 1600w, ${hintergrund2400Webp} 2400w`,
  ersatz: hintergrund960Webp,
};

/**
 * Der Schriftzug DUELINE (seit dem 15.10.2026 statt des Wappens mit den
 * Toren - das wirkte im Menue zu klein).
 */
export const MENUE_LOGO: Bildquellen = {
  avif: `${schriftzug480Avif} 480w, ${schriftzug960Avif} 960w, ${schriftzug1440Avif} 1440w`,
  webp: `${schriftzug480Webp} 480w, ${schriftzug960Webp} 960w, ${schriftzug1440Webp} 1440w`,
  ersatz: schriftzug480Webp,
};

/**
 * Die Portraets der Linebounds fuer die Auswahl (15.10.2026) - der obere Teil
 * der Homepage-Bilder im Hochformat 4:5. Schluessel: HEROES[].linebound,
 * klein geschrieben.
 */
export const LINEBOUND_BILDER: Readonly<Record<string, Bildquellen>> = {
  rovan: {
    avif: `${lbrovan240Avif} 240w, ${lbrovan480Avif} 480w`,
    webp: `${lbrovan240Webp} 240w, ${lbrovan480Webp} 480w`,
    ersatz: lbrovan240Webp,
  },
  aelys: {
    avif: `${lbaelys240Avif} 240w, ${lbaelys480Avif} 480w`,
    webp: `${lbaelys240Webp} 240w, ${lbaelys480Webp} 480w`,
    ersatz: lbaelys240Webp,
  },
  calder: {
    avif: `${lbcalder240Avif} 240w, ${lbcalder480Avif} 480w`,
    webp: `${lbcalder240Webp} 240w, ${lbcalder480Webp} 480w`,
    ersatz: lbcalder240Webp,
  },
  vessa: {
    avif: `${lbvessa240Avif} 240w, ${lbvessa480Avif} 480w`,
    webp: `${lbvessa240Webp} 240w, ${lbvessa480Webp} 480w`,
    ersatz: lbvessa240Webp,
  },
};
